var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading === true)?_c('v-row',[_c('v-col',[_vm._v(" "+_vm._s(_vm.$t('Loading'))+" "),_c('p'),(_vm.linear)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"orange darken-2"}}):_c('v-skeleton-loader',{attrs:{"loading":_vm.load,"transition":_vm.transition,"height":_vm.height,"type":"article"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }